import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { Translator } from "../../services/TranslationService";
import { ResetTopic } from "../../services/CabinetService";

export function ResetConfirmModal(props: {
    onAnswer: (a: boolean) => void,
    translator: Translator,
    topics: ResetTopic[],

}) {

    //const topicItems = [ResetTopic.Doors, ResetTopic.Dimensions, ResetTopic.Corpus, ResetTopic.Interior].map(topic => {
    const topicItems = props.topics.map(topic => {
        const translation = props.translator(
            `confirm reset topic ${topic}`,
            topic
        );
        return (<li className="list-group-item" key={topic}>{translation}</li>);
    });


    return (
        <Modal animation={false}
            show
            size="sm"
            onHide={() => props.onAnswer(false)}
        >
            <Modal.Header>
                <h4>{props.translator("confirm reset header", "Nulstil?")}</h4>
            </Modal.Header>

            <Modal.Body>
                {props.translator(
                    "confirm reset explainer before",
                    "Dette valg vil føre til at følgende dele af dit skab bliver nulstillet:"
                )}

                <ul className="list-group list-group-flush">
                    {topicItems}
                </ul>

                {props.translator("confirm reset explainer after", "Ønsker du at nulstille?")}
            </Modal.Body>

            <Modal.Footer>
                <Button variant="outline-secondary" onClick={() => props.onAnswer(false)}>
                    {props.translator("confirm reset cancel button", "Fortryd")}
                </Button>
                <Button variant="outline-danger" onClick={() => props.onAnswer(true)}>
                    {props.translator("confirm reset accept button", "Nulstil")}
                </Button>
            </Modal.Footer>
        </Modal>
        )
}
